import { render } from "./CupAgreementProducts.vue?vue&type=template&id=5c5aa8df&ts=true"
import script from "./CupAgreementProducts.vue?vue&type=script&lang=ts"
export * from "./CupAgreementProducts.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\Hermelin\\hermelinshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__